'use client';
"use strict";

var _excluded = ["onChange", "defaultIndex", "index", "allowMultiple", "allowToggle"],
  _excluded2 = ["isDisabled", "isFocusable", "id"],
  _excluded3 = ["children", "reduceMotion"],
  _excluded4 = ["htmlProps", "descendants"],
  _excluded5 = ["htmlProps"],
  _excluded6 = ["className", "motionProps"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Accordion: function Accordion() {
    return _Accordion;
  },
  AccordionButton: function AccordionButton() {
    return _AccordionButton;
  },
  AccordionIcon: function AccordionIcon() {
    return _AccordionIcon;
  },
  AccordionItem: function AccordionItem() {
    return _AccordionItem;
  },
  AccordionPanel: function AccordionPanel() {
    return _AccordionPanel;
  },
  AccordionProvider: function AccordionProvider() {
    return _AccordionProvider;
  },
  useAccordion: function useAccordion() {
    return _useAccordion;
  },
  useAccordionContext: function useAccordionContext() {
    return _useAccordionContext;
  },
  useAccordionItem: function useAccordionItem() {
    return _useAccordionItem;
  },
  useAccordionItemState: function useAccordionItemState() {
    return _useAccordionItemState;
  },
  useAccordionStyles: function useAccordionStyles() {
    return _useAccordionStyles;
  }
});
module.exports = __toCommonJS(src_exports);

// src/accordion.tsx
var import_system = require("@chakra-ui/system");
var import_shared_utils2 = require("@chakra-ui/shared-utils");
var import_react2 = require("react");

// src/accordion-context.ts
var import_descendant = require("@chakra-ui/descendant");
var import_react_context = require("@chakra-ui/react-context");
var _ref = (0, import_react_context.createContext)({
    name: "AccordionStylesContext",
    hookName: "useAccordionStyles",
    providerName: "<Accordion />"
  }),
  _ref2 = _slicedToArray(_ref, 2),
  AccordionStylesProvider = _ref2[0],
  _useAccordionStyles = _ref2[1];
var _ref3 = (0, import_react_context.createContext)({
    name: "AccordionItemContext",
    hookName: "useAccordionItemContext",
    providerName: "<AccordionItem />"
  }),
  _ref4 = _slicedToArray(_ref3, 2),
  AccordionItemProvider = _ref4[0],
  useAccordionItemContext = _ref4[1];
var _ref5 = (0, import_descendant.createDescendantContext)(),
  _ref6 = _slicedToArray(_ref5, 4),
  AccordionDescendantsProvider = _ref6[0],
  useAccordionDescendantsContext = _ref6[1],
  useAccordionDescendants = _ref6[2],
  useAccordionDescendant = _ref6[3];

// src/use-accordion.ts
var import_react_context2 = require("@chakra-ui/react-context");
var import_react_use_controllable_state = require("@chakra-ui/react-use-controllable-state");
var import_react_use_merge_refs = require("@chakra-ui/react-use-merge-refs");
var import_shared_utils = require("@chakra-ui/shared-utils");
var import_react = require("react");
function _useAccordion(props) {
  var onChange = props.onChange,
    defaultIndex = props.defaultIndex,
    indexProp = props.index,
    allowMultiple = props.allowMultiple,
    allowToggle = props.allowToggle,
    htmlProps = _objectWithoutProperties(props, _excluded);
  allowMultipleWarning(props);
  allowMultipleAndAllowToggleWarning(props);
  var descendants = useAccordionDescendants();
  var _ref7 = (0, import_react.useState)(-1),
    _ref8 = _slicedToArray(_ref7, 2),
    focusedIndex = _ref8[0],
    setFocusedIndex = _ref8[1];
  (0, import_react.useEffect)(function () {
    return function () {
      setFocusedIndex(-1);
    };
  }, []);
  var _ref9 = (0, import_react_use_controllable_state.useControllableState)({
      value: indexProp,
      defaultValue: function defaultValue() {
        if (allowMultiple) return defaultIndex != null ? defaultIndex : [];
        return defaultIndex != null ? defaultIndex : -1;
      },
      onChange: onChange
    }),
    _ref10 = _slicedToArray(_ref9, 2),
    index = _ref10[0],
    setIndex = _ref10[1];
  var getAccordionItemProps = function getAccordionItemProps(idx) {
    var isOpen = false;
    if (idx !== null) {
      isOpen = Array.isArray(index) ? index.includes(idx) : index === idx;
    }
    var onChange2 = function onChange2(isOpen2) {
      if (idx === null) return;
      if (allowMultiple && Array.isArray(index)) {
        var nextState = isOpen2 ? index.concat(idx) : index.filter(function (i) {
          return i !== idx;
        });
        setIndex(nextState);
      } else if (isOpen2) {
        setIndex(idx);
      } else if (allowToggle) {
        setIndex(-1);
      }
    };
    return {
      isOpen: isOpen,
      onChange: onChange2
    };
  };
  return {
    index: index,
    setIndex: setIndex,
    htmlProps: htmlProps,
    getAccordionItemProps: getAccordionItemProps,
    focusedIndex: focusedIndex,
    setFocusedIndex: setFocusedIndex,
    descendants: descendants
  };
}
var _ref11 = (0, import_react_context2.createContext)({
    name: "AccordionContext",
    hookName: "useAccordionContext",
    providerName: "Accordion"
  }),
  _ref12 = _slicedToArray(_ref11, 2),
  _AccordionProvider = _ref12[0],
  _useAccordionContext = _ref12[1];
function _useAccordionItem(props) {
  var isDisabled = props.isDisabled,
    isFocusable = props.isFocusable,
    id = props.id,
    htmlProps = _objectWithoutProperties(props, _excluded2);
  var _useAccordionContext2 = _useAccordionContext(),
    getAccordionItemProps = _useAccordionContext2.getAccordionItemProps,
    setFocusedIndex = _useAccordionContext2.setFocusedIndex;
  var buttonRef = (0, import_react.useRef)(null);
  var reactId = (0, import_react.useId)();
  var uid = id != null ? id : reactId;
  var buttonId = "accordion-button-".concat(uid);
  var panelId = "accordion-panel-".concat(uid);
  focusableNotDisabledWarning(props);
  var _useAccordionDescenda = useAccordionDescendant({
      disabled: isDisabled && !isFocusable
    }),
    register = _useAccordionDescenda.register,
    index = _useAccordionDescenda.index,
    descendants = _useAccordionDescenda.descendants;
  var _getAccordionItemProp = getAccordionItemProps(index === -1 ? null : index),
    isOpen = _getAccordionItemProp.isOpen,
    onChange = _getAccordionItemProp.onChange;
  warnIfOpenAndDisabled({
    isOpen: isOpen,
    isDisabled: isDisabled
  });
  var onOpen = function onOpen() {
    onChange == null ? void 0 : onChange(true);
  };
  var onClose = function onClose() {
    onChange == null ? void 0 : onChange(false);
  };
  var onClick = (0, import_react.useCallback)(function () {
    onChange == null ? void 0 : onChange(!isOpen);
    setFocusedIndex(index);
  }, [index, setFocusedIndex, isOpen, onChange]);
  var onKeyDown = (0, import_react.useCallback)(function (event) {
    var keyMap = {
      ArrowDown: function ArrowDown() {
        var next = descendants.nextEnabled(index);
        next == null ? void 0 : next.node.focus();
      },
      ArrowUp: function ArrowUp() {
        var prev = descendants.prevEnabled(index);
        prev == null ? void 0 : prev.node.focus();
      },
      Home: function Home() {
        var first = descendants.firstEnabled();
        first == null ? void 0 : first.node.focus();
      },
      End: function End() {
        var last = descendants.lastEnabled();
        last == null ? void 0 : last.node.focus();
      }
    };
    var action = keyMap[event.key];
    if (action) {
      event.preventDefault();
      action(event);
    }
  }, [descendants, index]);
  var onFocus = (0, import_react.useCallback)(function () {
    setFocusedIndex(index);
  }, [setFocusedIndex, index]);
  var getButtonProps = (0, import_react.useCallback)(function getButtonProps2() {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread(_objectSpread({}, props2), {}, {
      type: "button",
      ref: (0, import_react_use_merge_refs.mergeRefs)(register, buttonRef, ref),
      id: buttonId,
      disabled: !!isDisabled,
      "aria-expanded": !!isOpen,
      "aria-controls": panelId,
      onClick: (0, import_shared_utils.callAllHandlers)(props2.onClick, onClick),
      onFocus: (0, import_shared_utils.callAllHandlers)(props2.onFocus, onFocus),
      onKeyDown: (0, import_shared_utils.callAllHandlers)(props2.onKeyDown, onKeyDown)
    });
  }, [buttonId, isDisabled, isOpen, onClick, onFocus, onKeyDown, panelId, register]);
  var getPanelProps = (0, import_react.useCallback)(function getPanelProps2() {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread(_objectSpread({}, props2), {}, {
      ref: ref,
      role: "region",
      id: panelId,
      "aria-labelledby": buttonId,
      hidden: !isOpen
    });
  }, [buttonId, isOpen, panelId]);
  return {
    isOpen: isOpen,
    isDisabled: isDisabled,
    isFocusable: isFocusable,
    onOpen: onOpen,
    onClose: onClose,
    getButtonProps: getButtonProps,
    getPanelProps: getPanelProps,
    htmlProps: htmlProps
  };
}
function allowMultipleWarning(props) {
  var index = props.index || props.defaultIndex;
  var condition = index != null && !Array.isArray(index) && props.allowMultiple;
  (0, import_shared_utils.warn)({
    condition: !!condition,
    message: "If 'allowMultiple' is passed, then 'index' or 'defaultIndex' must be an array. You passed: ".concat(_typeof(index), ",")
  });
}
function allowMultipleAndAllowToggleWarning(props) {
  (0, import_shared_utils.warn)({
    condition: !!(props.allowMultiple && props.allowToggle),
    message: "If 'allowMultiple' is passed, 'allowToggle' will be ignored. Either remove 'allowToggle' or 'allowMultiple' depending on whether you want multiple accordions visible or not"
  });
}
function focusableNotDisabledWarning(props) {
  (0, import_shared_utils.warn)({
    condition: !!(props.isFocusable && !props.isDisabled),
    message: "Using only 'isFocusable', this prop is reserved for situations where you pass 'isDisabled' but you still want the element to receive focus (A11y). Either remove it or pass 'isDisabled' as well.\n    "
  });
}
function warnIfOpenAndDisabled(props) {
  (0, import_shared_utils.warn)({
    condition: props.isOpen && !!props.isDisabled,
    message: "Cannot open a disabled accordion item"
  });
}

// src/accordion.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var _Accordion = (0, import_system.forwardRef)(function Accordion2(_ref13, ref) {
  var children = _ref13.children,
    reduceMotion = _ref13.reduceMotion,
    props = _objectWithoutProperties(_ref13, _excluded3);
  var styles = (0, import_system.useMultiStyleConfig)("Accordion", props);
  var ownProps = (0, import_system.omitThemingProps)(props);
  var _useAccordion2 = _useAccordion(ownProps),
    htmlProps = _useAccordion2.htmlProps,
    descendants = _useAccordion2.descendants,
    context = _objectWithoutProperties(_useAccordion2, _excluded4);
  var ctx = (0, import_react2.useMemo)(function () {
    return _objectSpread(_objectSpread({}, context), {}, {
      reduceMotion: !!reduceMotion
    });
  }, [context, reduceMotion]);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(AccordionDescendantsProvider, {
    value: descendants,
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(_AccordionProvider, {
      value: ctx,
      children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(AccordionStylesProvider, {
        value: styles,
        children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_system.chakra.div, _objectSpread(_objectSpread({
          ref: ref
        }, htmlProps), {}, {
          className: (0, import_shared_utils2.cx)("chakra-accordion", props.className),
          __css: styles.root,
          children: children
        }))
      })
    })
  });
});
_Accordion.displayName = "Accordion";

// src/accordion-button.tsx
var import_system2 = require("@chakra-ui/system");
var import_shared_utils3 = require("@chakra-ui/shared-utils");
var import_jsx_runtime2 = require("react/jsx-runtime");
var _AccordionButton = (0, import_system2.forwardRef)(function AccordionButton2(props, ref) {
  var _useAccordionItemCont = useAccordionItemContext(),
    getButtonProps = _useAccordionItemCont.getButtonProps;
  var buttonProps = getButtonProps(props, ref);
  var styles = _useAccordionStyles();
  var buttonStyles = _objectSpread({
    display: "flex",
    alignItems: "center",
    width: "100%",
    outline: 0
  }, styles.button);
  return /* @__PURE__ */(0, import_jsx_runtime2.jsx)(import_system2.chakra.button, _objectSpread(_objectSpread({}, buttonProps), {}, {
    className: (0, import_shared_utils3.cx)("chakra-accordion__button", props.className),
    __css: buttonStyles
  }));
});
_AccordionButton.displayName = "AccordionButton";

// src/accordion-icon.tsx
var import_icon = require("@chakra-ui/icon");
var import_shared_utils4 = require("@chakra-ui/shared-utils");
var import_jsx_runtime3 = require("react/jsx-runtime");
function _AccordionIcon(props) {
  var _useAccordionItemCont2 = useAccordionItemContext(),
    isOpen = _useAccordionItemCont2.isOpen,
    isDisabled = _useAccordionItemCont2.isDisabled;
  var _useAccordionContext3 = _useAccordionContext(),
    reduceMotion = _useAccordionContext3.reduceMotion;
  var _className = (0, import_shared_utils4.cx)("chakra-accordion__icon", props.className);
  var styles = _useAccordionStyles();
  var iconStyles = _objectSpread({
    opacity: isDisabled ? 0.4 : 1,
    transform: isOpen ? "rotate(-180deg)" : void 0,
    transition: reduceMotion ? void 0 : "transform 0.2s",
    transformOrigin: "center"
  }, styles.icon);
  return /* @__PURE__ */(0, import_jsx_runtime3.jsx)(import_icon.Icon, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    "aria-hidden": true,
    className: _className,
    __css: iconStyles
  }, props), {}, {
    children: /* @__PURE__ */(0, import_jsx_runtime3.jsx)("path", {
      fill: "currentColor",
      d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
    })
  }));
}
_AccordionIcon.displayName = "AccordionIcon";

// src/accordion-item.tsx
var import_system3 = require("@chakra-ui/system");
var import_shared_utils5 = require("@chakra-ui/shared-utils");
var import_react3 = require("react");
var import_jsx_runtime4 = require("react/jsx-runtime");
var _AccordionItem = (0, import_system3.forwardRef)(function AccordionItem2(props, ref) {
  var children = props.children,
    className = props.className;
  var _useAccordionItem2 = _useAccordionItem(props),
    htmlProps = _useAccordionItem2.htmlProps,
    context = _objectWithoutProperties(_useAccordionItem2, _excluded5);
  var styles = _useAccordionStyles();
  var containerStyles = _objectSpread(_objectSpread({}, styles.container), {}, {
    overflowAnchor: "none"
  });
  var ctx = (0, import_react3.useMemo)(function () {
    return context;
  }, [context]);
  return /* @__PURE__ */(0, import_jsx_runtime4.jsx)(AccordionItemProvider, {
    value: ctx,
    children: /* @__PURE__ */(0, import_jsx_runtime4.jsx)(import_system3.chakra.div, _objectSpread(_objectSpread({
      ref: ref
    }, htmlProps), {}, {
      className: (0, import_shared_utils5.cx)("chakra-accordion__item", className),
      __css: containerStyles,
      children: typeof children === "function" ? children({
        isExpanded: !!context.isOpen,
        isDisabled: !!context.isDisabled
      }) : children
    }))
  });
});
_AccordionItem.displayName = "AccordionItem";

// src/accordion-panel.tsx
var import_system4 = require("@chakra-ui/system");
var import_transition = require("@chakra-ui/transition");
var import_shared_utils6 = require("@chakra-ui/shared-utils");
var import_jsx_runtime5 = require("react/jsx-runtime");
var _AccordionPanel = (0, import_system4.forwardRef)(function AccordionPanel2(props, ref) {
  var className = props.className,
    motionProps = props.motionProps,
    rest = _objectWithoutProperties(props, _excluded6);
  var _useAccordionContext4 = _useAccordionContext(),
    reduceMotion = _useAccordionContext4.reduceMotion;
  var _useAccordionItemCont3 = useAccordionItemContext(),
    getPanelProps = _useAccordionItemCont3.getPanelProps,
    isOpen = _useAccordionItemCont3.isOpen;
  var panelProps = getPanelProps(rest, ref);
  var _className = (0, import_shared_utils6.cx)("chakra-accordion__panel", className);
  var styles = _useAccordionStyles();
  if (!reduceMotion) {
    delete panelProps.hidden;
  }
  var child = /* @__PURE__ */(0, import_jsx_runtime5.jsx)(import_system4.chakra.div, _objectSpread(_objectSpread({}, panelProps), {}, {
    __css: styles.panel,
    className: _className
  }));
  if (!reduceMotion) {
    return /* @__PURE__ */(0, import_jsx_runtime5.jsx)(import_transition.Collapse, _objectSpread(_objectSpread({
      "in": isOpen
    }, motionProps), {}, {
      children: child
    }));
  }
  return child;
});
_AccordionPanel.displayName = "AccordionPanel";

// src/use-accordion-item-state.ts
function _useAccordionItemState() {
  var _useAccordionItemCont4 = useAccordionItemContext(),
    isOpen = _useAccordionItemCont4.isOpen,
    isDisabled = _useAccordionItemCont4.isDisabled,
    onClose = _useAccordionItemCont4.onClose,
    onOpen = _useAccordionItemCont4.onOpen;
  return {
    isOpen: isOpen,
    onClose: onClose,
    isDisabled: isDisabled,
    onOpen: onOpen
  };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Accordion: _Accordion,
  AccordionButton: _AccordionButton,
  AccordionIcon: _AccordionIcon,
  AccordionItem: _AccordionItem,
  AccordionPanel: _AccordionPanel,
  AccordionProvider: _AccordionProvider,
  useAccordion: _useAccordion,
  useAccordionContext: _useAccordionContext,
  useAccordionItem: _useAccordionItem,
  useAccordionItemState: _useAccordionItemState,
  useAccordionStyles: _useAccordionStyles
});